import request from '@/utils/request'

export function listComplaints(params) {
    return request({
      url: '/complaint/listComplaints',
      method: 'get',
      params
    })
  }

// 查询业主优惠券列表
export function listCouponPropertyUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponProperty.listCouponPropertyUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
          total: res.total
        })
      } else {
        reject(new Error(res.msg || 'Failed to query coupon property user'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
